module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "inject_foo"
    }
  }, [_vm._v(_vm._s(_vm.foo))]), _vm._v(" "), _c('sk-site-header', {
    ref: "site-header",
    staticClass: "no-print",
    on: {
      "change": _vm.resendActivation
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1), _vm._v(" "), _c('router-view', {
    staticClass: "main-view"
  }), _vm._v(" "), _c('sk-site-footer', {
    staticClass: "no-print"
  }), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDialog),
      callback: function($$v) {
        _vm.toggleDialog = $$v
      },
      expression: "toggleDialog"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.sysError)
    }
  }), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": 20
    }
  }), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.okay($event)
      }
    }
  }, [_vm._v("Ok")])], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "50%",
      "persistent": "",
      "lazy": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.activationDialog),
      callback: function($$v) {
        _vm.activationDialog = $$v
      },
      expression: "activationDialog"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs),
      expression: "$breakpoints.xs"
    }],
    staticClass: "dialog__header"
  }, [_c('sk-icon', {
    staticClass: "dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  })], 1), _vm._v(" "), _c('sk-icon', {
    staticClass: "hidden-xs dialog__header-close",
    attrs: {
      "close": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Activation Code Sent")]), _vm._v(" "), _c('p', [_vm._v("Please check your mail in order to activate your account.")]), _vm._v(" "), _c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.activationDialog = false
      }
    }
  }, [_vm._v("Dismiss")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e7e3a0b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 477
// module chunks = 0